export enum ProductionStationColumnEnum {
  OrderItemId = 0,
  ProductionScheduledStartDate = 1,
  Material = 2,
  ProductionID = 3,
  ProductionStationID = 4,
  Note = 5,
  ParentOrderItemId = 6,
  MakeupQty = 7,
  MakeUpNote = 8,
  DateTimeStarted = 9,
  DateTimeEnded = 10,
  StaffID = 11,
  StaffName = 12,
  CompletedByStaffId = 13,
  ColorReportSort = 14,
  Width = 15,
  ProductionProcessId = 16,
  NoteToProductionTeam = 17,
  CustomerName = 18,
  // Ponumber = 19,
  OrderId = 20,
  Qty = 21,
  Ac = 22,
  Length = 23,
  PartId = 24,
  AngleCut = 25,
  AttachmentId = 26,
  AdditionToLength = 27,
  AddLength2PlyWelting = 28,
  ColorCodeLabels = 29,
  CutHeaderSize = 30,
  Color = 31,
  AngleEquation = 32,
  PlyEquation = 33,
  PlyId = 34,
  MaterialId = 35,
  FoamPartsSheet = 36,
  NoteToProductionTeamSpecific = 37,
  ShipDate = 38,
  // DueDate = 39,
  Attachment = 40,
  WidthDescription = 41,
  Description = 42,
  DrawingLink = 43,
  GallopPartNumber = 44,
  PartNumber = 45,
  Emergency = 46,
  CoreGuardSleeve = 47,
  ShowTableNo = 48,
  CutAt = 50,
  ArrivalDate=51,
  Batch=52,
}
